import { Route, Routes } from "react-router-dom"
import SettingsLimits from "../../../pages/SettingsLimits"

const SettingsLimitsFlow = () => (
  <Routes>
    <Route element={<SettingsLimits />} index />
  </Routes>
)

export default SettingsLimitsFlow
